// packages
import moment from 'moment';

/**
 *
 * Criação do objecto de resolve de chamada.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 * @param {Object}  helpers
 *
*/
const create = ( data, { structureQuestions }) => {
    // construção da estrutura das respostas
    // para ser enviado para API.
    const answers = Object.keys( data )
        // Obtenção das respostas do script que tem como nome
        // números ( correspondem aos id's ) e que o groupo de campo
        // não tenha a classe `display--none`. Com a segunda condição
        // evita-se que os campos que foram preenchidos numa outra sequencia
        // do guião sejam enviados para API.
        .filter( key => /^\d+$/.test( key )
            && !document.querySelector( `.script__question[data-id="${key}"]` ).classList.contains( 'display--none' ) )
        .reduce( ( answer, key, index ) => {
            const { possibleAnswers } = structureQuestions[key];

            // definição dos valores default.
            let answerId = possibleAnswers[0].value;
            let value = data[key];

            // validação se existe mais que uma resposta possível
            // caso exista, quer dizer que que o id da resposta é o valor
            // selecionado através da input ( radiobutton ) e não é necessário enviar o
            // o valor para a API.
            if ( possibleAnswers.length > 1 ) {
                answerId = data[key];
                value = null;
            }

            // definção do id da resposta.
            answer[`answers[${index}][script_answer_id]`] = answerId;

            // validação se existe valor.
            if ( value )
                answer[`answers[${index}][value]`] = value;

            return answer;
        }, {});

    const resolveCall = {
        id: data.id,
        _method: 'post',
        ...( data.stateId && { state_id: data.stateId }),
        ...( data.rescheduleTo && {
            reschedule_to: moment( data.rescheduleTo ).utc().format( 'YYYY-MM-DD HH:mm' ),
            ...( data.newContactValue && {
                new_contact_type: 'phone',
                new_contact_value: data.newContactValue
            })
        }),
        ...( Object.keys( answers ).length && { ...answers }),
        ...( data.internalObservations && { observations: data.internalObservations })
    };

    return resolveCall;
};

const requiredFields = [ { field: 'stateId', isRequiredOnEdit: false } ];

export {
    create,
    requiredFields
};